export enum AcbTransactionEnum {

  'Imported'= 1,
  'Processed',
  'Rejected',
  'Completed',
  'Manually Processed',
  'Cancelled',
  'In Tracking',
  'To be Linked',
  'Recalled',
  'Duplicated',
  'Not Found',
  'SummaryDetail'
}

export namespace AcbTransactionEnum {
  export function values() {
    return Object.keys(AcbTransactionEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
